import { api } from './client'

export type SkillCol = { id: number; name: string }
export type SkillRow = {
  user: { id: number; name: string; email: string; avatar_color: string | null }
  levels: Array<{ skill_id: number; name: string; level: number }>
}
export type SkillMatrix = { skills: SkillCol[]; rows: SkillRow[] }

export async function getSkillMatrix(): Promise<SkillMatrix> {
  return api<SkillMatrix>('/lookups/skill-matrix')
}

export type WorkloadRow = {
  user_id: number
  name: string
  email: string
  avatar_color: string | null
  story_count: number
  total_points: number
  done_points: number
  capacity: number
  load_pct: number
  focus: { epic_id: number; epic_name: string; epic_color: string | null } | null
}

export type WorkloadBubble = {
  id: number
  name: string
  color: string | null
  total_points: number
  story_count: number
  people: Array<{ user_id: number; name: string; avatar_color: string | null; points: number }>
}

export type TeamWorkload = {
  sprint_id: number | null
  rows: WorkloadRow[]
  bubbles: WorkloadBubble[]
}

export async function getTeamWorkload(opts: { project_id?: number; sprint_id?: number }): Promise<TeamWorkload> {
  return api<TeamWorkload>('/lookups/team-workload', { query: opts })
}
